import React, { useMemo } from 'react';
import { ControlLink, LoadingBalls } from '@moda/om';
import loadable from '@loadable/component';
import { LineItem } from '../../../hooks/useCart/cart.rest';
import { LineItemType } from '../lineItemMutations.rest';
import { useAdminMode } from '../../AdminMode/AdminModeProvider';

import './LineItemActions.scss';

type Props = {
  item: LineItem;
  index?: number;
  onDelete: () => void;
  onChangeType: (type: LineItemType) => void;
};

const AdminModeForCartItems = loadable(() => import('../../AdminMode/AdminModeForCartItems'), {
  fallback: <LoadingBalls />
});

export const LineItemActions: React.FC<Props> = ({ item, index, onDelete, onChangeType }) => {
  const { enabled: adminModeEnabled } = useAdminMode();
  const { inventory, skuId, isProductAvailable } = item.attributes;

  const isSizeSoldOut = useMemo(
    () => inventory.find(item => item.id === skuId)?.available === 0,
    [inventory, skuId]
  );
  const removeDataTestId = item.type === 'saved_items' ? 'savedForLater' : 'cartItem';
  return (
    <div className="LineItemActions">
      {adminModeEnabled && <AdminModeForCartItems item={item} />}

      {item.type === 'cart_items' && (
        <ControlLink
          onClick={() => onChangeType('SavedItem')}
          data-testid={`saveForLater-${index}`}
        >
          Save for later
        </ControlLink>
      )}

      {item.type === 'saved_items' && isProductAvailable && !isSizeSoldOut && (
        <ControlLink
          onClick={() => onChangeType('CartItem')}
          data-testid={`savedForLatermoveToBag-${index}`}
        >
          Move to bag
        </ControlLink>
      )}

      <ControlLink
        data-testid={`${removeDataTestId}RemoveFromShoppingBag-${index}`}
        onClick={onDelete}
      >
        Remove
      </ControlLink>
    </div>
  );
};
